import { render, staticRenderFns } from "./BusinessNamePartners.vue?vue&type=template&id=56f5ddd4&scoped=true&"
import script from "./BusinessNamePartners.vue?vue&type=script&lang=js&"
export * from "./BusinessNamePartners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f5ddd4",
  null
  
)

export default component.exports